import React from "react";
import { TableInput } from "components/common/input";
import type { IAskGraveMoveDetail } from "service/interface/apply";

interface Props {
  data: IAskGraveMoveDetail;
  setData: React.Dispatch<React.SetStateAction<IAskGraveMoveDetail>>;
}

export function DetailInfoTable({ data, setData }: Props) {
  const handleCurrentAddressInput = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setData((prev) => ({
      ...prev,
      currentAddress: e.target.value,
    }));
  };

  const handleMoveAddressInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setData((prev) => ({
      ...prev,
      moveAddress: e.target.value,
    }));
  };

  return (
    <div>
      <div className="mb-[24px] flex items-center justify-between">
        <p className="m-0 text-[24px] font-semibold leading-[30px] text-black">
          상세 정보
        </p>
      </div>
      <div className="w-full border-t-[2px] border-t-black p-0">
        <div className="flex h-[86px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            현 묘지 주소
          </div>
          <div className="flex h-full w-[787px] items-center px-[16px] text-M3 text-gray-5">
            <TableInput
              value={data.currentAddress}
              onChange={handleCurrentAddressInput}
            />
          </div>
        </div>
        <div className="flex h-[86px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            새로 모실 곳
          </div>
          <div className="flex h-full w-[787px] items-center px-[16px] text-M3 text-gray-5">
            <TableInput
              value={data.moveAddress}
              onChange={handleMoveAddressInput}
            />
          </div>
        </div>
        <div className="flex h-[58px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            추모 공원 상담
          </div>
          <div className="flex h-full w-[787px] items-center px-[24px] text-M3 text-gray-5">
            {data.isConsulting ? "예" : "아니오"}
          </div>
        </div>
        <div className="flex h-[190px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            기타
          </div>
          <div className="flex h-full w-[787px] items-center px-[24px] py-[18px] text-M3 text-gray-5">
            <textarea
              value={data.requestTerm}
              readOnly
              spellCheck={false}
              className="m-0 h-[154px] w-full resize-none border-none p-0 text-M3 text-gray-5 outline-none focus:border-white focus:ring-0 focus:ring-white"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
